import ResizeObserver from 'react-resize-observer'
import { runInAction } from 'mobx'

import { storeElement } from 'GlobalStores/StoreElement'

const DynamicWidthObserver = () => (
    <ResizeObserver
        onResize={size => {
            if (size.width !== storeElement.dynamicWidth) {
                runInAction(() => {
                    storeElement.dynamicWidth = size.width
                })
            }
        }}
    />
)

export default DynamicWidthObserver

